import { Maybe, TaskStatus } from "apps/platform-client/client/src/models/generated/graphql";
import { InboxTaskProps } from "./InboxTask";
import { InboxTaskContentPayload } from "./InboxTaskContent";
import { GetUserInboxTasksQuery } from "./types/queries.generated";
import { NotificationsType } from "apps/platform-client/client/src/models/common/notifications";

const mapContent = (triggerEventId: number | undefined, t: any | null, flexEntityTypes: GetUserInboxTasksQuery["flexEntityTypes"]) => {
	switch (triggerEventId) {
		case NotificationsType.AgreementApproval:
			return <InboxTaskContentPayload>{
				agreementId: t?.agreement?.id || 0,
				agreementName: t?.agreement?.name || "",
				taskStatus: t?.taskStatus || null,
				triggerEventId,
			};
		case NotificationsType.RefundInvoiceReview:
		case NotificationsType.RefundInvoiceResendForReview:
		case NotificationsType.RefundInvoiceReceiverApproval:
		case NotificationsType.RefundInvoiceReceiverRejection:
		case NotificationsType.RefundInvoiceReceiverConfirmation:
		case NotificationsType.RefundInvoiceSenderConfirmation:
		case NotificationsType.RefundInvoiceSenderRejection:
			return <InboxTaskContentPayload>{
				triggerEventId,
				invoiceId: t?.document?.id,
				taskStatus: t?.taskStatus || null,
				orgCreator: t?.createdBy?.organization.name || "",
				type: t?.document?.type,
			};
		case NotificationsType.FormDueExact:
			return <InboxTaskContentPayload>{
				triggerEventId,
				caseId: t?.caseConnection.edges[0].node.id,
				formType:
					t?.caseConnection.edges[0]?.formDueOrOverdue && flexEntityTypes
						? flexEntityTypes.find((entity: any) => entity.id === t?.caseConnection.edges[0]?.formDueOrOverdue)
								?.localizationKey || ""
						: "",
				taskStatus: t?.taskStatus || null,
			};
		case NotificationsType.NegotiableAttributeProposal:
			return <InboxTaskContentPayload>{
				triggerEventId,
				caseId: t?.caseConnection.edges[0]?.node.id,
			};

		default:
			return <InboxTaskContentPayload>{
				agreementId: "",
				agreementName: "",
				triggerEventId,
			};
	}
};

const getAssigneeStatus = (triggerEventId: number | undefined, t: any | null, currentUser: any) => {
	switch (triggerEventId) {
		case NotificationsType.AgreementApproval:
			return t?.node?.agreement?.userRolesConnection?.edges?.some((edge: any) => edge.isAssignee && edge.node.id === currentUser.id);

		case NotificationsType.RefundInvoiceReview:
		case NotificationsType.RefundInvoiceResendForReview:
		case NotificationsType.RefundInvoiceReceiverConfirmation:
		case NotificationsType.RefundInvoiceReceiverApproval:
		case NotificationsType.RefundInvoiceReceiverRejection:
		case NotificationsType.RefundInvoiceSenderConfirmation:
		case NotificationsType.RefundInvoiceSenderRejection:
			return t?.node?.document?.assignedTo?.some((user: any) => user.id === currentUser.id);

		case NotificationsType.NegotiableAttributeProposal:
		case NotificationsType.FormDueExact:
			return t?.node?.caseConnection?.edges?.some((edge: any) =>
				edge.node?.caseAssignee?.some((user: any) => user.id === currentUser.id)
			);
	}
};

export default (d: Maybe<any>, currentUser: any, flexEntityTypes: any[]): Array<Maybe<InboxTaskProps>> => {
	if (!d?.tasks) return [];

	return d?.tasks && d.tasks[0]
		? d.tasks[0].tasksConnection.edges
				.filter((task: any) => task.node.createdBy?.id !== currentUser.id)
				.map((t: any, i: number) => ({
					triggerEventId: t ? t.node.triggerEventId : 0,
					taskDate: t?.node?.timeStamp || 0,
					content: mapContent(t?.node.triggerEventId, t.node, flexEntityTypes),
					index: i,
					isCompleted: !!t.isCompleted,
					taskStatus: t?.node?.taskStatus || TaskStatus.Read,
					taskId: t.node.id,
					isAssignee: getAssigneeStatus(t.node.triggerEventId, t, currentUser),
				}))
		: [];
};
